import api from '../REST/api';
import { markUiAction } from '../utils/create-ui-action';

// eslint-disable-next-line import/prefer-default-export
export const fetchMediaSetRequirements = () => (dispatch, getState) => {
  const { mediaSetRequirements } = getState();
  if (mediaSetRequirements.length) {
    return Promise.resolve({ value: mediaSetRequirements });
  }
  return dispatch(
    markUiAction({
      type: fetchMediaSetRequirements.toString(),
      payload: api.getMediaSetRequirements(),
    }),
  );
};

fetchMediaSetRequirements.toString = () => 'mediaSetRequirements/fetch';
